import { useMemo } from 'react';
import { useGamification } from '../hooks/GamificationContext';

function normalizeItem(item) {
  if (!item) return null;
  if (typeof item === 'string') {
    return {
      key: item,
      title: item,
      badge_icon: '🏅',
      rarity: 'common',
    };
  }

  const title = item.title || '';
  if (!title) return null;

  return {
    key: item.key || title,
    title,
    badge_icon: item.badge_icon || '🏅',
    badge_image_url: item.badge_image_url || '',
    description: item.description || '',
    rarity: item.rarity || 'common',
    presentation_type: item.presentation_type || 'achievement',
    sound_url: item.sound_url || '',
    popup_title: item.popup_title || title,
    popup_text: item.popup_text || item.description || '',
    awarded_at: item.awarded_at || '',
  };
}

export function useAchievements() {
  const { achievement_items = [], achievements = [] } = useGamification();

  return useMemo(() => {
    const source = Array.isArray(achievement_items) && achievement_items.length
      ? achievement_items
      : Array.isArray(achievements)
        ? achievements
        : [];

    const seen = new Set();
    const items = [];

    source.forEach((raw) => {
      const item = normalizeItem(raw);
      if (!item) return;

      if (seen.has(item.key)) return;
      seen.add(item.key);
      items.push(item);
    });

    return items;
  }, [achievement_items, achievements]);
}
